export default "<iw-dashboard></iw-dashboard>\n";